import React, { useState } from 'react';
import styled from 'styled-components';
import { Link } from 'gatsby';

import MainNavCTA from './elements/MainNavCTA';

import Arrow from './elements/NavigationArrow';

const SubmenuSectionStyle = styled.div`
	display: flex;
	flex-direction: column;
	gap: 2rem;
`;

const MobileMenuLink = styled(Link)`
	font-family: ${({ theme }) => theme.fonts.subheadingMedium};
	font-size: 1.3rem;
	line-height: 100%; /* 15px */
	letter-spacing: 0.15px;
	position: relative;
	display: block;
	color: ${({ theme }) => theme.colors.black.main};
`;

const MobileSubheaderText = styled.span`
	font-size: 1.3rem;
	font-family: ${({ theme }) => theme.fonts.body};
	line-height: 20px; /* 160% */
	letter-spacing: 0.13px;
`;

const SubmenuSection = ({ menuTitleLink, items }) => {
	return (
		<SubmenuSectionStyle>
			{menuTitleLink && (
				<MobileMenuLink to={menuTitleLink}>Learn More</MobileMenuLink>
			)}
			{items.map((item, index) => {
				return (
					<div>
						<MobileMenuLink
							key={item.contentful_id}
							to={item.linkUrl}
							openInNewTab
						>
							{item.linkMainText && item.linkMainText}
						</MobileMenuLink>
						<MobileSubheaderText>
							{item.linkSubTextLong &&
								item.contentful_id !== '3FzqSzDf0xHU6M7XwbG8qx' &&
								item?.linkSubTextLong?.linkSubTextLong}
						</MobileSubheaderText>
					</div>
				);
			})}
		</SubmenuSectionStyle>
	);
};

const SubmenuWrapper = styled.div`
	display: flex;
	flex-direction: column;
	gap: 2rem;
	margin: 1rem 0px 2rem;
`;

const MobileMenuLinkHeader = styled.span`
	font-family: ${({ theme }) => theme.fonts.callout600};
	font-size: 1.3rem; /* 13px */
	line-height: 100%; /* 13px */
	letter-spacing: 0.13px;
	text-transform: uppercase;
`;

const Submenu = ({ section, index }) => {
	const sectionHead = section.menuTitle;

	return (
		<SubmenuWrapper>
			{sectionHead ? (
				<>
					<MobileMenuLinkHeader>{section.menuTitle}</MobileMenuLinkHeader>
					<SubmenuSection
						menuTitleLink={section.menuTitleLink}
						items={section.menuItems}
						noImage={index === 0}
					/>
				</>
			) : (
				<SubmenuSection items={section.menuItems} />
			)}
		</SubmenuWrapper>
	);
};

const Wrapper = styled.div`
	min-height: calc(
		100dvh -
			(
				${({ theme }) => theme.fixedHeights.announcementBar}px +
					${({ theme }) => theme.fixedHeights.navBar}px
			)
	);
	max-height: 100%;
	width: 100%;
	visibility: ${props => (props.open ? 'visible' : 'hidden')};
	opacity: ${props => (props.open ? 1 : 0)};
	transition: all 0.6s ease;
	background-color: ${({ theme }) => theme.colors.white.main};
	overflow: hidden scroll;
	display: block;
	position: relative;
	padding: 0 5%;
	${({ theme }) => theme.mediaQuery.breakpointLg} {
		display: none;
	}
`;

const TopLevelLinkWrapper = styled.span`
	:hover {
		cursor: pointer;
	}
	padding: 15px 0;
	font-family: ${({ theme }) => theme.fonts.subheadingMedium};
	font-size: 1.5rem;
	line-height: 100%; /* 15px */
	letter-spacing: 0.15px;
	position: relative;
	display: flex;
	flex-direction: row;
	justify-content: space-between;

	a {
		color: ${({ theme }) => theme.colors.black.main};
	}
`;

const Slider = styled.div`
	overflow: hidden;
	transition: all 0.75s;
	${props =>
		props.open
			? `max-height: 200vh;
        padding: 20px 0;`
			: `max-height: 0px;`}
`;

export default ({
	menu,
	productInnerMenu,
	toggle,
	open,
	noFooterMenu,
	className,
	...props
}) => {
	const [openIndex, setOpenIndex] = useState(null);
	const handleClick = index => {
		if (index === openIndex) {
			setOpenIndex(null);
		} else {
			setOpenIndex(index);
		}
	};

	return (
		<Wrapper open={open} className={className}>
			{menu?.map((topLevel, index) => {
				const title = topLevel.menuTitle || topLevel.linkMainText;
				let columns = topLevel.menuItems;

				return (
					<>
						{topLevel.menuItems ? (
							<TopLevelLinkWrapper
								key={`title-${title}`}
								onClick={() => handleClick(index)}
							>
								{title}
								<Arrow rotating={openIndex === index} />
							</TopLevelLinkWrapper>
						) : (
							<TopLevelLinkWrapper key={`title-${title}`}>
								<Link
									onClick={toggle}
									to={topLevel.linkUrl}
									anchorLink={topLevel.anchorLink}
								>
									{title}
								</Link>
							</TopLevelLinkWrapper>
						)}
						{columns && (
							<Slider open={openIndex === index}>
								{columns.map((column, index) => (
									<Submenu
										index={index}
										key={`menu-column-${columns[index].contentful_id || columns[index].menuTitle}`}
										toggle={toggle}
										section={column}
									/>
								))}
							</Slider>
						)}
					</>
				);
			})}
			<MainNavCTA />
		</Wrapper>
	);
};
